import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/client/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/client/';

class ClientService {
  createClient(client) {
    return axios.post(API_URL , client);
  }

  updateClient(client) {
    return axios.put(API_URL , client);
  }

  updateClientByClient(client) {
    return axios.put(API_URL  + 'update/contact-details', client);
  }

  getClients() {
    return axios.get(API_URL + 'all');
  }

  getClientTypes() {
    return axios.get(API_URL + 'types');
  }

  getUsersOfClient(clientId, simplified = false) {
    return axios.get(API_URL + 'users/' + clientId, { params:{ simplified } });
  }

  getUsersOfSomeClient(simplified) {
    return axios.get(API_URL + 'users', { params:{ simplified } });
  }

  getLeaguesOfClient(clientId) {
    return axios.get(API_URL + 'leagues/' + clientId);
  }

  getSeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/seasons');
  }

  getTinySeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/seasons-tiny');
  }

  getPhysicalSeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/physical-seasons');
  }

  getPhysicalSeasonsOfClientWithProvider12(clientId) {
    return axios.get(API_URL  + clientId + '/physical-seasons-provider-12');
  }

  switchClientLeague(clientId, leagueId, isClientActive,area = null) {
    return axios.post(API_URL + 'switch-client-league',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActive,
        area: area
      }
     );
  }

  switchClientLeagueHub(clientId, leagueId, isClientActive,area = null) {
    return axios.post(API_URL + 'switch-client-league-hub',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActive,
        area: area
      }
    );
  }

  switchSeasonOfClient(clientId, seasonId, state, productId) {
    return axios.post(API_URL + 'switch-client-season',
      {
        clientId: clientId,
        seasonId: seasonId,
        state: state,
        productId: productId
      }
     );
  }

  loadSeasonList() {
    return axios.get(`${API_URL}season-list`);
  }

  createSeasonList(seasonList) {
    return axios.post(`${API_URL}season-list`, seasonList);
  }

  updateSeasonList(seasonList) {
    return axios.put(`${API_URL}season-list/${seasonList.id}`,seasonList);
  }

  deleteSeasonList(seasonList) {
    return axios.delete(`${API_URL}season-list/${seasonList.id}`);
  }

  getClientById(clientId){
    return axios.get(API_URL + clientId);
  }

  getElementIdsWithVideo(){
    return axios.get(API_URL + "elements-with-video");
  }

  getGamesWithVideo(){
    return axios.get(API_URL + "games-with-video");
  }

  getActiveUsersOfClient(clientId) {
    return axios.get(API_URL + 'active-users/' + clientId);
  }

  getLastLoginOfActiveClients() {
    return axios.get(API_URL + 'last-login');
  }

  getClientAcademyTeams() {
    return axios.get(API_URL + 'academy-teams');
  }

  getCapture(clientId){
    return axios.get(`${API_URL}${clientId}/capture`);
  }

  postCapture(clientId,capture){
    return axios.post(`${API_URL}${clientId}/capture`,capture);
  }

  putCapture(clientId,capture){
    return axios.put(`${API_URL}${clientId}/capture`,capture);
  }

  getTotalRequestedGames(clientId){
    return axios.get(`${API_URL}${clientId}/requested`);
  }
  
  postClientTeamAcademy(clientId,teamId){
    return axios.post(`${API_URL}${clientId}/academy-team/${teamId}`);
  }
}

export default new ClientService();



// WEBPACK FOOTER //
// ./src/services/client.service.js